import { onAuthStateChanged } from "firebase/auth";
import React, { useEffect } from "react";
import { Outlet, useNavigate } from "react-router-dom";
import { fAuth } from "../../firebase";
import Header from "../Header";
import Footer from "./Footer";

const MainLayout = () => {
  const navigate = useNavigate();
  useEffect(() => {
    onAuthStateChanged(fAuth, (user) => {
      if (user) {
        // navigate("/dashboard");
      } else {
        navigate("/login");
      }
    });
  }, [navigate]);
  return (
    <div className="min-h-screen bg-gray-900">
      <Header />

      <main className="pt-[57px]">
        <div className=" p-6">
          <Outlet />
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default MainLayout;
